export default "__VITE_ASSET__BQ49ECIn__"